module.exports = __webpack_public_path__ + "img/BE0881221640.b6229bcb.png";